<template>
	<div class="vx-row">
		<div id="optimization-download-content" class="vx-col w-full vs-con-loading__container">
			<vx-card no-shadow card-border>
				<vs-sidebar
					id="jobCreate"
					parent="body"
					click-not-close
					position-right
					default-index="1"
					color="primary"
					class="add-new-data-sidebar items-no-padding"
					v-model="isSidebarAddActive"
				>
					<div class="flex items-center justify-between px-6 p-4" style="background: #eee">
						<h4>{{ $t("Jobs.CreateJobPlanning") }}</h4>
						<feather-icon
							icon="XIcon"
							@click.stop="isSidebarAddActive = false"
							class="cursor-pointer"
						></feather-icon>
					</div>
					<job-create
						v-if="isSidebarAddActive"
						@toggleAllEmit="expandRelevantTabs()"
						@closeSidebarEmit="closeSidebarAdd()"
					/>
				</vs-sidebar>
				<div class="flex justify-between items-center pr-1">
					<vs-navbar-title class="float-right">
						<span class="text-primary"
							>{{ $t("Jobs.SelectedJobs") + ":" }} {{ jobsSelected ? jobsSelected.length : 0 }}</span
						>
					</vs-navbar-title>
					<div class="flex justify-center items-center">
						<vs-button
							class="mr-2"
							type="border"
							icon="icon-info"
							icon-pack="feather"
							@click.prevent="openInformation()"
						/>
						<vs-button
							v-if="jobsSelected.length > 0"
							class="mr-2"
							type="filled"
							icon-pack="feather"
							:title="$t('UploadFiles.Download') + ' ' + $t('Jobs.SelectedJobs')"
							:icon="'icon-download'"
							@click.prevent="activeDownload()"
						/>
						<vs-button
							v-if="jobsSelected.length > 0"
							class="mr-2"
							color="primary"
							type="border"
							icon-pack="feather"
							:title="isExpandedPickup ? $t('CollapseEverything') : $t('ExpandAll')"
							:icon="isExpandedPickup ? 'icon-minimize-2' : 'icon-maximize-2'"
							@click.prevent="expandRelevantTabs()"
						></vs-button>
						<vs-dropdown
							vs-trigger-click
							class="ml-auto cursor-pointer"
							:title="$t('Jobs.CreateJobPlanning')"
						>
							<vs-button color="primary" type="border" icon="icon-plus" icon-pack="feather" />
							<vs-dropdown-menu :style="{width: windowWidth > 620 ? '20%' : '50%'}">
								<h4 class="p-4">{{ $t("Jobs.JobPlanning") }}</h4>
								<vs-dropdown-item>
									<div
										class="flex items-center"
										:title="$t('Jobs.CreateJobPlanning')"
										@click.prevent="showSidebar()"
									>
										<feather-icon
											icon="PlusSquareIcon"
											class="inline-block mr-2 color-logo"
											svgClasses="w-5 h-5"
										/>
										<span>{{ $t("CompanyModule.Add") }}</span>
									</div>
								</vs-dropdown-item>
								<vs-dropdown-group :vs-label="$t('Upload') + ' ' + $t('UploadFiles.File')">
									<vs-dropdown-item>
										<div class="flex items-center" @click.prevent="uploadFileMounted = true">
											<feather-icon
												icon="FilePlusIcon"
												class="inline-block mr-2 color-logo"
												svgClasses="w-5 h-5"
											/>
											<span>{{ $t("Jobs.AddJobsByFileUpload") }}</span>
										</div>
									</vs-dropdown-item>
									<vs-dropdown-item>
										<div class="flex items-center" @click.prevent="downloadJobTemplate()">
											<feather-icon
												icon="DownloadIcon"
												class="inline-block mr-2 color-logo"
												svgClasses="w-5 h-5"
											/>
											<span>{{ $t("Jobs.DownloadTemplate") }}</span>
										</div>
									</vs-dropdown-item>
								</vs-dropdown-group>
							</vs-dropdown-menu>
						</vs-dropdown>
					</div>
				</div>
				<div v-if="jobsSelected.length > 0" class="vx-col w-full lg:block mt-2 pr-1">
					<div class="flex items-center justify-end">
						<template>
							<vs-dropdown vs-trigger-click class="cursor-pointer">
								<div
									class="p-3 mr-2 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer font-medium"
								>
									<span class="mr-2">{{ $t("SearchBy") }} {{ searchSelected }}</span>
									<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
								</div>
								<vs-dropdown-menu>
									<vs-dropdown-item @click="setSearchField('Name')">
										<span>{{ $t("ResourceModule.Table.Name") }}</span>
									</vs-dropdown-item>
								</vs-dropdown-menu>
							</vs-dropdown>
						</template>
						<vs-input
							v-model="searchQueryJobs"
							icon="icon-search"
							icon-pack="feather"
							class="w-full md:w-1/2"
							:placeholder="$t('Teams.Form.Add') + ' ' + searchSelected"
						/>
					</div>
				</div>
				<vue-perfect-scrollbar class="scroll-area" :settings="settings">
					<job-planning-item
						ref="ListSelectedItemJobs"
						:jobsSelected="getJobList"
						:searchQueryJobs="searchQueryJobs"
						@getExpanded="getExpandedPickup"
					></job-planning-item>
				</vue-perfect-scrollbar>
			</vx-card>
		</div>
		<optimization-download
			:activeDownload="isActiveDownload"
			:dataToDownload="jobsSelected"
			fieldsOptimization="jobs"
			:textTitle="$t('Jobs.JobPlanning')"
			@activePopupEmit="activePopup"
		/>
		<vs-popup
			class="vs-popup--content-custom"
			:fullscreen="true"
			:title="$t('Jobs.JobPlanning')"
			:active.sync="uploadFileMounted"
		>
			<upload-file
				ref="uploadJobAdd"
				typeUploadFile="JOB_UPLOAD"
				typeAction="ADD"
				inputFileId="inputFileJobAdd"
				inputFileIcon="BriefcaseIcon"
				:activateListUploadFile="false"
				:showUploadFileOptimization="showUploadFileOptimization"
				:showSetEquivalenceOptimization="showSetEquivalenceOptimization"
				@setUploadFileOptimization="setUploadFileOptimization"
				@setEquivalenceOptimization="setEquivalenceOptimization"
				@closePopupEmit="closePopupAddUploadFile"
			/>
		</vs-popup>
	</div>
</template>

<script>
import vSelect from "vue-select";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moduleOptimization from "@/store/optimization/moduleOptimization.js";
import JobPlanningItem from "@/components/optimization/jobs/JobPlanningItem.vue";
import JobCreate from "@/components/optimization/jobs/create/JobCreate.vue";
import UploadFile from "@/components/optimization/upload-file/UploadFile.vue";
import OptimizationDownload from "@/components/optimization/OptimizationDownload.vue";
import {downloadJobUploadTemplate} from "@/helpers/jobUploadTemplate.js";

export default {
	name: "JobPlanningForm",
	components: {
		vSelect,
		VuePerfectScrollbar,
		JobPlanningItem,
		JobCreate,
		UploadFile,
		OptimizationDownload,
	},
	data() {
		return {
			isMounted: false,
			searchQuery: [],
			isSidebarAddActive: false,
			searchQueryJobs: null,
			searchFieldShipping: "Name",
			searchField: {value: "Name", label: this.$t("Routing.Table.Name")},
			isExpandedPickup: false,
			isActiveDownload: false,
			uploadFileMounted: false,
			showUploadFileOptimization: true,
			showSetEquivalenceOptimization: false,
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
		};
	},
	watch: {
		searchFieldSelected(val) {
			if (val) {
				this.searchQueryJobs = null;
			}
		},
		async uploadFileMounted(val) {
			if (!val && this.$refs.uploadJobAdd) {
				await this.$refs.uploadJobAdd.cancelEquivalenceEmit();
				this.$refs.uploadJobAdd.cleanData();
				this.$store.commit("moduleOptimization/REMOVE_ALL_UPLOAD_FILE_JOB");
				this.$store.commit("moduleOptimization/REMOVE_ALL_CHECKED_UPLOAD_FILE_JOB");
			}
		},
	},
	computed: {
		jobsSelected() {
			const jobs = this.$store.state.moduleOptimization.standardInputList["jobs"];
			return jobs === undefined || jobs === "" || jobs === null ? [] : jobs;
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		iconSize() {
			return this.$store.state.windowWidth < 620 ? "small" : "medium";
		},
		searchSelected() {
			return this.$t(`${this.searchFieldShipping}`);
		},
		getJobList() {
			return this.getFilteredJobList(this.jobsSelected, this.searchQueryJobs);
		},
	},
	mounted() {
		this.isMounted = true;
	},
	created() {
		if (!moduleOptimization.isRegistered) {
			this.$store.registerModule("moduleOptimization", moduleOptimization);
			moduleOptimization.isRegistered = true;
		}
	},
	methods: {
		showSidebar() {
			this.isSidebarAddActive = true;
		},
		closeSidebar() {
			this.isSidebarAddActive = false;
		},
		setSearchField(val) {
			this.searchFieldShipping = val;
		},
		expandRelevantTabs() {
			this.$refs.ListSelectedItemJobs.toggleAll();
		},
		getExpandedPickup(val) {
			this.isExpandedPickup = val;
		},
		closeSidebarAdd() {
			this.isSidebarAddActive = false;
		},
		getFilteredJobList(items, searchQuery) {
			if (!searchQuery || searchQuery.trim().length === 0) {
				return items;
			}
			return items.filter((r) => {
				return r.name.toLowerCase().includes(searchQuery.toLowerCase());
			});
		},
		openInformation() {
			this.$vs.dialog({
				type: "alert",
				color: "success",
				title: this.$t("Information"),
				text: this.$t("Jobs.JobsAreUsedToAssociateADeliveryWithAPickup"),
				acceptText: this.$t("Routing.Title.Close"),
			});
		},
		activeDownload() {
			this.isActiveDownload = true;
		},
		activePopup(val) {
			this.isActiveDownload = val;
		},
		closePopupAddUploadFile() {
			this.uploadFileMounted = false;
		},
		setUploadFileOptimization(val) {
			this.showUploadFileOptimization = val;
		},
		setEquivalenceOptimization(val) {
			this.showSetEquivalenceOptimization = val;
		},
		downloadJobTemplate() {
			try {
				downloadJobUploadTemplate(this.$t("Jobs.TemplateFileName"));
				this.$vs.notify({
					color: "success",
					title: this.$t("Success"),
					text: this.$t("Jobs.TemplateDownloadSuccess"),
				});
			} catch (error) {
				console.error(error);
				this.$vs.notify({
					color: "danger",
					title: this.$t("Error"),
					text: this.$t("UploadFiles.DownloadFailedText"),
				});
			}
		},
	},
};
</script>

<style lang="scss" scoped>
#content-router-selection {
	height: 100%;
}

.scroll-area {
	margin: auto;
	width: 100%;
	min-height: 450px;
	max-height: 400px;
}
.content-form-create {
	width: 100%;
	min-height: 550px;
	max-height: 650px;
}
.add-new-data-sidebar {
	::v-deep .vs-sidebar--background {
		z-index: 50000;
	}

	::v-deep .vs-sidebar {
		z-index: 50000;
		width: 10000px;
		max-width: 90vw;

		.img-upload {
			margin-top: 2rem;

			.con-img-upload {
				padding: 0;
			}

			.con-input-upload {
				width: 100%;
				margin: 0;
			}
		}
	}
}
.is-stuck {
	position: fixed;
	top: 52px;
	inset-inline-start: 0;
	margin-inline-start: 30px;
	width: calc(100% - 80px);
	z-index: 14;
}
.form-header-inner {
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.is-stuck--datarutas {
	position: fixed;
	top: 52px;
	inset-inline-start: 0;
	margin-inline-start: 30px;
	width: calc(100% - 60px);
	z-index: 14;
}
.color-logo {
	color: rgba(35, 39, 133, 1);
}
</style>
